import { render, staticRenderFns } from "./editor-panel-overrides.vue?vue&type=template&id=1cbc958a"
import script from "./editor-panel-overrides.vue?vue&type=script&lang=js"
export * from "./editor-panel-overrides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports